import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as moment from 'moment';


declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-trop-percus',
  templateUrl: './trop-percus.component.html',
  styleUrls: ['./trop-percus.component.css']
})
export class TropPercusComponent implements OnInit {
  @Input() detail;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  @Output() show = new EventEmitter<any>();

  isEmpty: Boolean = true;
  renderTable: Boolean = true;
  isHisto: Boolean = false;
  default = 0;
  nbdigit;
  classPresta: String = 'detailfact ';
  focusIndex = 0;
  listTropPercus = [];
  deleteElm = [];
  article: any = {};
  selectedRow: any = {};
  dataArticle = [{ id: 0, libelleObjetEntite: 'Aucun' }];
  error = '';

  @ViewChild('msg') msg;

  constructor(public common: CommonService, private modalService: BsModalService) {
    this.nbdigit = this.common.local.getObject('paramSociete').nbDigitDevise;
  }

  ngOnInit() {
    this.article = this.dataArticle[0];
    this.getListTropPercus().then(() => {
      this.isEmpty = false;
    });
  }

  showHisto() {
    this.isHisto = !this.isHisto;
    this.listTropPercus = [];
    this.getListTropPercus();
  }

  parseDate() {
    this.listTropPercus.forEach(elt => {
      elt.date = elt.date ? moment(elt.date, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY')
        : moment().format('DD/MM/YYYY');
    });
  }

  hide() {
    this.show.emit();
  }

  change(row) {
    row.edit = true;
  }

  deleteLigne(row) {
    if (row.id) {
      this.deleteElm.push(row);
      this.deleteElm = [...this.deleteElm];
    }
    const temp = this.listTropPercus.filter(elt => elt !== row);
    this.listTropPercus = temp;
  }

  /*deleteLigne(row) {
    const temp = this.listTropPercus.filter(elt => elt !== row);
    this.listTropPercus = temp;
  }*/

  addLigne() {
    this.listTropPercus.push({
      index: this.listTropPercus.length, id: 0, date: moment().format('DD/MM/YYYY')
    });
    this.listTropPercus = [...this.listTropPercus];
    const length = this.listTropPercus.length - 1;
    setTimeout(function () {
      $('.date' + (length)).focus();
    }, 600);
  }

  getListTropPercus() {
    const param = {
      'servlet': 'DBGestionTropPercu',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'ID_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']
        },
        'IS_HISTO': {
          'typeParam': 'boolean',
          'valeur': this.isHisto
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      $('.ligneBon').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listTropPercus = datas.data;
        this.parseDate();
      }
    });
  }

  focus(event) {
    const input = event.target;
    const originalValue = $(input).val();
    $(input).val('');
    $(input).blur().focus().val(originalValue);
  }

  valide() {
    const prom = [];
    if (this.deleteElm.length) {
      this.deleteElm.forEach(elt => {
        const fct = this.delete(elt);
        prom.push(fct);
      });
    }
    const add = this.listTropPercus.filter(elt => !elt.id);
    if (add.length) {
      add.forEach(elt => {
        elt.id = 0;
        elt.clefClient = this.detail['id'] || 0;
        const fct = this.saveAdd(elt);
        prom.push(fct);
      });
    }

    const edit = this.listTropPercus.filter(elt => elt.id && elt.edit);
    if (edit.length) {
      edit.forEach(elt => {
        elt.clefClient = this.detail['id'] || 0;
        const fct = this.saveEdit(elt);
        prom.push(fct);
      });
    }
    if (prom.length) {
      Promise.all(prom).then(data => {
        if (data.length) {
          this.getMontantTropPercu();
          this.hide();
        }

      }).catch(error => {
        this.common.closeModal();
        console.log(error);
      });
    } else {
      this.getMontantTropPercu();
      this.hide();
    }
  }

  getMontantTropPercu() {
    const param = {
      'servlet': 'DBGestionTropPercu',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'ID_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      if (this.common.verifySession(datas)) {
        this.detail['montantTropPercu'] = datas.data;
      }
    });
  }

  saveAdd(row) {
    row.nomclass = 'TropPercu';
    row.montant = parseFloat(('' + (row.montant || 0)).replace(/,/g, "."));
    const param = {
      'servlet': 'DBGestionTropPercu',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'TROP_PERCU': row
      }
    };

    return this.common.post('', { param: param }).then(data => {
      if (data.message) {
        return Promise.reject(data.message);
      } else {
        return data;
      }
    });
  }

  saveEdit(row) {
    row.nomclass = 'TropPercu';
    row.montant = parseFloat(('' + (row.montant || 0)).replace(/,/g, "."));
    const param = {
      'servlet': 'DBGestionTropPercu',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'TROP_PERCU': row
      }
    };

    return this.common.post('', { param: param }).then(data => {
      if (data.message) {
        return Promise.reject(data.message);
      } else {
        return data;
      }
    });
  }

  delete(row) {
    row.nomclass = 'TropPercu';
    const param = {
      'servlet': 'DBGestionTropPercu',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 5
        },
        'ID_TROP_PERCU': {
          'typeParam': 'int',
          'valeur': row.id
        },
      }
    };

    return this.common.post('', { param: param }).then(data => {
      if (data.message) {
        return Promise.reject(data.message);
      } else {
        return data;
      }
    });
  }

  rembourser(row) {

    if (this.article && this.article['id']) {
      this.common.closeModal();
      row.nomclass = 'TropPercu';
      row.clefClient = this.detail['id'] || 0;
      this.article['nomclass'] = 'Article';
      const param = {
        'servlet': 'DBGestionTropPercu',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 6
          },
          'TROP_PERCU': row,
          'ARTICLE': this.article
        }
      };

      return this.common.post('', { param: param }).then(datas => {
        $('#empty').trigger('click');
        this.getListTropPercus();
        this.getMontantTropPercu();
        this.article = this.dataArticle[0];
        if (this.common.verifySession(datas)) {
          console.log(datas);
        }
      });
    } else {
      this.error = 'Le champ "Article" doit être renseigné.';
      this.common.openModal(this.modalService, this.msg);
    }
  }

  searchArticle(event) {
    this.dataArticle = [{ id: 0, libelleObjetEntite: 'Aucun' }];
    const param = 2;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.dataArticle = [...this.dataArticle, ...datas.data];
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

}
